import React from 'react';
import { connect } from 'react-redux';
import { setLocale } from '../../actions/intl';
import COPY from './copy.json';
import {
  t, PHONE, PHONE_LABEL, initReveal, Figure,
  IconPhone, IconTick,
  Header, Footer, CallBar
} from './SiteChrome';

/*
 * Halaman "Drive with us" — port dari site/providers.html.
 *
 * ANGKA DI SINI ADALAH JANJI KOMERSIAL KE CALON MITRA: payout median AED 4.800,
 * komisi 18%, bayaran mingguan, persetujuan satu hari kerja. Berbeda dari angka
 * pemasaran biasa — ini bisa dianggap ketentuan kerja sama. Wajib dikonfirmasi
 * client sebelum tayang.
 */

const REQS = ['vehicle', 'licence', 'id', 'registration'];
const STEPS = [1, 2, 3];
const MONEY = [1, 2, 3, 4, 5];
const FAQ_KEYS = [1, 2, 3, 4, 5];

const PROVIDER_APP = 'https://play.google.com/store/apps/details?id=com.nagmalshamalportal.basrecoveryproviders';

const LD_FAQ = {
  '@context': 'https://schema.org', '@type': 'FAQPage',
  mainEntity: FAQ_KEYS.map(n => ({
    '@type': 'Question', name: COPY['en-US']['prv.faq.' + n + '.q'],
    acceptedAnswer: { '@type': 'Answer', text: COPY['en-US']['prv.faq.' + n + '.a'] }
  }))
};

class Providers extends React.Component {
  state = { navOpen: false };

  toggleNav = () => this.setState(s => ({ navOpen: !s.navOpen }));
  closeNav = () => this.setState({ navOpen: false });

  switchLang = () => {
    const next = this.props.currentLocale === 'ar' ? 'en-US' : 'ar';
    document.documentElement.lang = next;
    this.props.setLocale({ locale: next });
  };

  componentDidMount() {
    this.onKey = e => { if (e.key === 'Escape') this.closeNav(); };
    document.addEventListener('keydown', this.onKey);
    this.io = initReveal();
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.onKey);
    if (this.io) this.io.disconnect();
  }

  render() {
    const { navOpen } = this.state;
    const L = this.props.currentLocale || 'en-US';
    const tx = (k, v) => t(L, k, v);

    return (
      <div>
        <a className="skip" href="#main">{tx('nav.skip')}</a>

        <Header
          locale={L} current="/providers"
          navOpen={navOpen}
          onToggleNav={this.toggleNav}
          onCloseNav={this.closeNav}
          onSwitchLang={this.switchLang}
        />

        <main id="main">
          <section className="hero" style={{ paddingBlock: 'clamp(40px,6vw,72px) clamp(44px,7vw,76px)' }}>
            <div className="wrap hero-grid">
              <div>
                <p className="eyebrow">{tx('nav.providers')}</p>
                <h1 style={{ fontSize: 'var(--fs-h1)', maxWidth: '22ch' }}>{tx('prv.h1')}</h1>
                <p className="lead">{tx('prv.lead')}</p>
                <div className="hero-cta">
                  <a className="btn btn-call btn-lg" href="/contact">{tx('prv.apply')}</a>
                  <a className="btn btn-ghost btn-lg" href={PROVIDER_APP}>{tx('prv.getApp')}</a>
                </div>
                <p className="hero-note"><IconTick /> {tx('prv.note')}</p>
              </div>

              <aside className="eta-card" aria-label={tx('prv.earnAria')}>
                <div className="eta-big" style={{ fontSize: 'clamp(38px,5vw,56px)' }}>
                  <span style={{ fontSize: '.42em' }}>AED </span>4,800
                </div>
                <p className="eta-label">{tx('prv.payoutLabel')}</p>
                <div className="eta-rule" />
                <div className="eta-rows">
                  {[1, 2, 3, 4].map(n => (
                    <div className="eta-row" key={n}>
                      <IconTick /><span><b>{tx(`prv.perk.${n}b`)}</b>{tx(`prv.perk.${n}`)}</span>
                    </div>
                  ))}
                </div>
              </aside>
            </div>
          </section>

          {/* ── SYARAT ── */}
          <section>
            <div className="wrap">
              <div className="sec-head">
                <h2>{tx('prv.req.h2')}</h2>
                <p className="lead">{tx('prv.req.lead')}</p>
              </div>
              <div className="svc-grid">
                {REQS.map(k => (
                  <div className="svc" key={k}>
                    <h3>{tx(`prv.req.${k}.title`)}</h3>
                    <p>{tx(`prv.req.${k}.body`)}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ── CARA BERGABUNG ── */}
          <section className="band-warm">
            <div className="wrap">
              <div className="sec-head"><h2>{tx('prv.how.h2')}</h2></div>
              <div className="steps">
                {STEPS.map(n => (
                  <div className="step" key={n}>
                    <h3>{tx(`prv.how.${n}.title`)}</h3>
                    <p>{tx(`prv.how.${n}.body`)}</p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* ── SOAL UANG ── */}
          <section>
            <div className="wrap split">
              <div>
                <h2>{tx('prv.money.h2')}</h2>
                <p className="lead">{tx('prv.money.lead')}</p>
                <div className="ticks">
                  {MONEY.map(n => (
                    <div className="tick" key={n}>
                      <IconTick /><span><strong>{tx(`prv.money.${n}b`)}</strong>{tx(`prv.money.${n}`)}</span>
                    </div>
                  ))}
                </div>
              </div>
              <Figure photo="partner" alt={tx('prv.figureAlt')} caption={tx('prv.figure')} />
            </div>
          </section>

          {/* ── FAQ ── */}
          <section>
            <div className="wrap-narrow">
              <div className="sec-head"><h2>{tx('prv.faq.h2')}</h2></div>
              <div className="faq">
                {FAQ_KEYS.map((n, i) => (
                  <details key={n} open={i === 0}>
                    <summary>{tx(`prv.faq.${n}.q`)}</summary>
                    <div><p>{tx(`prv.faq.${n}.a`)}</p></div>
                  </details>
                ))}
              </div>
            </div>
          </section>

          {/* ── CTA ── */}
          <section className="band-night">
            <div className="wrap" style={{ textAlign: 'center' }}>
              <h2 style={{ maxWidth: '24ch', marginInline: 'auto' }}>{tx('prv.cta.h2')}</h2>
              <p style={{ maxWidth: '50ch', margin: 'var(--sp-4) auto var(--sp-6)' }}>{tx('prv.cta.lead')}</p>
              <div style={{ display: 'flex', gap: 'var(--sp-3)', justifyContent: 'center', flexWrap: 'wrap' }}>
                <a className="btn btn-call btn-lg" href="/contact">{tx('prv.apply')}</a>
                <a className="btn btn-ghost btn-lg" href={`tel:${PHONE}`}>
                  <IconPhone />{tx('prv.ask')}
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer locale={L} />
        <CallBar locale={L} />

        <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(LD_FAQ) }} />
      </div>
    );
  }
}

const mapState = state => ({ currentLocale: state?.intl?.locale });
const mapDispatch = { setLocale };

export default connect(mapState, mapDispatch)(Providers);
